export default __webpack_public_path__ + "static/media/CX_loading_circle.005ad376.svg";